import { ProcessCommentsContainer } from 'app/Surveys/ProcessCommentsContainer';
import * as jQuery from 'jquery'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { CommentCodesContainer } from './app/Admin/CommentCodesContainer';
import { CognitoUser } from './app/Login/lib/CognitoUser';
import { LoginContainer } from './app/Login/LoginContainer';
import { SurveyManagementContainer } from './app/SurveyManagement/SurveyManagementContainer';
import { ImportQuestion } from './app/Surveys/ImportQuestion';
import { SurveyReviewContainer } from './app/Surveys/SurveyReviewContainer';
import { AttritionRiskToggle } from './components/ui/AttritionRiskToggle';
import { NewAppToast } from './components/ui/NewAppToast';
import { FiltersBar } from './components/ui/FiltersBar';
import { CustomPeriodsFilter } from './components/ui/FiltersBar/components/CustomPeriodsFilter';
import { PeriodsFilter } from './components/ui/FiltersBar/components/PeriodsFilter';
import { QuestionsPopover } from './components/ui/QuestionsPopover'
import { UserSearchSelect } from "./components/ui/UserSearchSelect";
import { getPreviousDateRange } from './components/util';
import { ChangePasswordContainer } from './containers/ChangePassword'
import { CoachingFormContainer } from './containers/CoachingFormContainer'
import { CoachingFormHeader } from './containers/CoachingFormHeader'
import { ActionAlertsAdminContainer } from './containers/ActionAlertsAdminContainer';
import { ActionAlertsReportsContainer } from './containers/ActionAlertsReportsContainer';
import { ActionAlertsAgingReportsContainer } from './containers/ActionAlertsAgingReportsContainer';
import { ActionAlertFormContainer } from "./containers/ActionAlertFormContainer";
import { CoachingFormsContainer } from './containers/CoachingFormsContainer';
import { CoachingFormStatus } from './containers/CoachingFormStatus'
import { CommentDetailsContainer } from './containers/CommentDetails/CommentDetailsContainer';
import { CustomReportsContainer } from './containers/CustomReports';
import { ForgotPasswordContainer } from './containers/ForgotPasswordContainer';
import { ManageAvidsHierarchiesAndSegmentsContainer } from './containers/ManageAvidsHierarchiesAndSegmentsContainer';
import { NewProjectContainer } from './containers/NewProjectContainer';
import { ProfileContainer } from './containers/ProfileContainer';
import { RankingReportCreationContainer } from './containers/RankingReportCreationContainer';
import { RunReportContainer } from './containers/RankingReportContainer/runReportContainer';
import { RankingReportContainer } from "./containers/RankingReportContainer";
import { SegmentsContainer } from './containers/SegmentsContainer';
import { MyAlertsContainer } from "./containers/MyAlertsContainer";
import { UserSettingsReportContainer } from './containers/UserSettingsReportContainer'
import { SocialMediaDashboardContainer } from './containers/SocialMediaDashboardContainer'
import { SocialMediaDetailsContainer } from './containers/SocialMediaDetailsContainer'
import { SocialMediaCoachingForm } from './containers/SocialMediaCoachingForm'
import { UserHierarchyManagementContainer } from "./containers/UserHierarchyManagementContainer";
import { HierarchyPermissionContainer } from "./containers/HierarchyPermissionContainer";
import { UserAdministrationContainer } from './containers/UserAdministrationContainer';
import { PasswordValidationRules } from './containers/ProfileContainer/lib/PasswordValidationRules'
import { SingleSurveyDashboardContainer } from './containers/SingleSurveyDashboardContainer';
import { ExportComponent } from './containers/UserActivityReportContainer';
import { DrilldownDashboardContainer } from './containers/DrilldownDashboardContainer';
import { ClientDashboardContainer } from './containers/ClientDashboardContainer';
import { UsersDashboardContainer } from './containers/UsersContainer';
import { ForgotUsernameContainer } from "./containers/ForgotUsernameContainer";
import SupportSubmissionFormContainer from "./containers/SupportSubmissionFormContainer"
import MFA_ChallengeContainer from './containers/MFA_ChallengeContainer';

import { AdminSurveysContainer } from './containers/AdminSurveysContainer'
import { getHierarchy, getReportDefinition, hardDeleteReport, getCalculationPrecision } from './containers/RankingReportCreationContainer/lib/https';
import { isObjectEqual } from './containers/MyAlertsContainer/lib/utils';
import { myAlertsDataLoader } from './util/dataLoader';
import { IndividualSurveysDashboardContainer } from './containers/IndividualSurveysDashboardContainer';
import { CommentsDashboardContainer } from './containers/CommentsDashboardContainer';
import { SmartSummariesContainer } from './containers/SmartSummariesContainer';
import { SegmentsGrid } from 'containers/SegmentsGridContainer';
import { CoachingFormNotesGrid } from 'containers/CoachingFormNotesGridContainer';

import { HttpRequest } from './util/http'
import { userData } from './util/userData'

/**
 * Render or re-render react component
 * @param node
 * @param componentType
 * @param props
 * @param callback
 * @param shouldUnmount
 */
const render = <T extends {}>(node: HTMLElement, componentType: React.ComponentType<T>, props?: T, callback?: () => void, shouldUnmount?: boolean) => {
  if (shouldUnmount) {
    // Unmount any component rendered at the node first
    ReactDOM.unmountComponentAtNode(node);
  }

  const instance = React.createElement(componentType, props);
  return ReactDOM.render(instance, node, callback);
};

//Re-authorize User and bounce if fails
CognitoUser.GetLoggedInUser(true)

/**
 * Containers for consumption
 */
const containers = {
  CoachingFormContainer,
  CoachingFormStatus,
  ClientDashboardContainer,
  UserSettingsReportContainer,
  CoachingFormHeader,
  ActionAlertsAdminContainer,
  ActionAlertsReportsContainer,
  ActionAlertsAgingReportsContainer,
  ActionAlertFormContainer,
  NewProjectContainer,
  CustomReportsContainer,
  SegmentsContainer,
  ManageAvidsHierarchiesAndSegmentsContainer,
  CoachingFormsContainer,
  ChangePasswordContainer,
  ForgotPasswordContainer,
  LoginContainer,
  ProfileContainer,
  SurveyManagementContainer,
  CommentDetailsContainer,
  CommentCodesContainer,
  SurveyReviewContainer,
  ProcessCommentsContainer,
  MyAlertsContainer,
  SocialMediaDashboardContainer,
  SocialMediaDetailsContainer,
  SocialMediaCoachingForm,
  UserHierarchyManagementContainer,
  AdminSurveysContainer,
  RankingReportContainer,
  RankingReportCreationContainer,
  RunReportContainer,
  HierarchyPermissionContainer,
  UserAdministrationContainer,
  PasswordValidationRules,
  SingleSurveyDashboardContainer,
  ExportComponent,
  DrilldownDashboardContainer,
  IndividualSurveysDashboardContainer,
  CommentsDashboardContainer,
  UsersDashboardContainer,
  ForgotUsernameContainer,
  SupportSubmissionFormContainer,
  MFA_ChallengeContainer,
  SmartSummariesContainer,
  SegmentsGrid,
  CoachingFormNotesGrid
}

/**
 * Containers for consumption
 */
const components = {
  QuestionsPopover,
  FiltersBar,
  PeriodsFilter,
  CustomPeriodsFilter,
  ImportQuestion,
  AttritionRiskToggle,
  UserSearchSelect,
  ExportComponent,
  DrilldownDashboardContainer,
  IndividualSurveysDashboardContainer,
  NewAppToast,
}

/**
 * Utils for consumption
 */
const utils = {
  HttpRequest,
  userData,
  CognitoUser,
  getReportDefinition,
  hardDeleteReport,
  getHierarchy,
  getPreviousDateRange,
  isObjectEqual,
  myAlertsDataLoader,
  getCalculationPrecision,
}

//Export to global space for consumption
window.AvannisTSX = { containers, components, render, utils, unmountComponent: ReactDOM.unmountComponentAtNode }
window.jQuery = jQuery
window.$ = jQuery
